import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HashLink as Link } from 'react-router-hash-link';

import APIHandler from 'config/APIHandler';
import StorageHandler from 'config/StorageHandler';

import InputField from 'components/LoginForm/Input';
import { storageKeys } from 'config/settings.json';
import { toast, cssTransition } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Zoom = cssTransition({
  enter: 'zoomIn',
  exit: 'zoomOut',
  duration: [500, 800],
});

export default class Forgot extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clientId: '',
    };
    this.forgotHandler = this.forgotHandler.bind(this);
  }

  componentDidMount() {
    this.getAppInfo();
  }

  getAppInfo() {
    StorageHandler.load(storageKeys.appInfo).then((appInfo) => {
      if (appInfo) {
        const { clientId } = appInfo;
        this.setState({ clientId });
      }
    });
  }

  async forgotHandler(event) {
    const { clientId } = this.state;
    const submit = event.target;
    submit.disabled = true;
    event.preventDefault();
    const email = this.props.defaultVal;
    this.props.setAnim('loadingAnimForgot', true);
    await APIHandler.forgotPassword(email, clientId).then((res) => {
      if (res.status !== 200) {
        this.props.setAnim('loadingAnimForgot', false);
        submit.disabled = false;
        toast.error(
          i18n.translate('loginScreen.version2.toastMessage.emailNotExisting'),
          {
            position: 'top-center',
            transition: Zoom,
            autoClose: 10000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          }
        );
      } else {
        this.props.setAnim('loadingAnimForgot', false);
        submit.disabled = false;
        toast.info(
          i18n.translate('loginScreen.version2.toastMessage.forgotSuccess'),
          {
            position: 'top-center',
            transition: Zoom,
            autoClose: 10000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          }
        );
        window.setTimeout(() => {
          window.location.href = '/login';
        }, 10000);
      }
    });
  }

  render() {
    const { defaultVal, change, back, loadingAnimRegister } = this.props;
    return (
      <div className="Forgot">
        <p>{i18n.translate('loginScreen.fields.forgot')}</p>
        <InputField
          defaultVal={defaultVal}
          change={change}
          fieldType="email"
          fieldName="email"
          fieldPlaceholder={i18n.translate('loginScreen.fields.email')}
          icon="envelope"
          focus
          line
        />
        <div className="login__form--buttons">
          <Link to="/login">
            <button
              type="button"
              onClick={back}
              className="Email__input--button btnInverse"
            >
              {i18n.translate('general.back')}
            </button>
          </Link>
          <button
            type="submit"
            onClick={this.forgotHandler}
            className="Email__input--button"
          >
            {loadingAnimRegister ? (
              <span>
                <FontAwesomeIcon icon={['fas', 'circle-notch']} spin />
              </span>
            ) : (
              'Submit'
            )}
          </button>
        </div>
      </div>
    );
  }
}

Forgot.propTypes = {
  back: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  defaultVal: PropTypes.string,
  loadingAnimRegister: PropTypes.bool.isRequired,
  setAnim: PropTypes.func.isRequired,
};

Forgot.defaultProps = {
  defaultVal: '',
};
